module.exports = __webpack_public_path__ + "img/mind_skeleton_8.87d56618.png";